import React from 'react';
import nick from '../../../images/nick.png';

function HelpNick() {

    return (
        <img src={nick} className="nick" alt="nick" />
      )
}
  
export default HelpNick;
